import { useCallback } from 'react'
import { GroupRow, AggregationType } from '../types'

export function useAggregation() {
  const getGroupAggregation = useCallback(
    (group: GroupRow, field: string, type: AggregationType = 'sum') => {
      if (!group.children || group.children.length === 0) return ''

      switch (type) {
        case 'sum':
          return group.children.reduce(
            (sum: number, item: any) => sum + (Number(item[field]) || 0),
            0
          )
        case 'avg':
          const sum = group.children.reduce(
            (sum: number, item: any) => sum + (Number(item[field]) || 0),
            0
          )
          return group.children.length ? sum / group.children.length : 0
        case 'count':
          return group.children.length
        case 'min':
          return Math.min(
            ...group.children.map((item: any) => Number(item[field]) || 0)
          )
        case 'max':
          return Math.max(
            ...group.children.map((item: any) => Number(item[field]) || 0)
          )
        default:
          return ''
      }
    },
    []
  )

  return { getGroupAggregation }
}
